import React, { useEffect, useState } from "react";
import alertCircle from "../../../assets/icons/alert-circle.svg";
import Tooltip from "@mui/material/Tooltip";
import "../CustomerPreview.scss";
import { route } from "../../../services/apiRoutes";
import { useDispatch, useSelector } from "react-redux";
import SnackbarAlert from "../../../shared-components/snackbar-alert/SnackbarAlert";
import { ERROR_MESSAGE, BOOKING_FORM_STATUS } from "../../../config/constant";
import SignInModal from "./SignInModal";
import Loader from "../../../components/Loader";
import { io } from "socket.io-client";
import { useHistory, useParams } from "react-router-dom";
import checkIcon from "../../../assets/icons/check-green.svg";
import {
  getApplicantDetails,
  signForApplicant,
} from "../../new-booking-form/new-booking-form.slice";
import { useHandleRedirection } from "../../new-booking-form/hooks/useHandleRedirection";
const { REACT_APP_SOCKET_SERVER_URL } = process.env;
let windowPopup = "";

const TermsAndConditionPreview = () => {
  const [applicatList, setApplicatList] = useState([]);
  const [acceptTermsAndCondition, setAcceptTermsAndCondition] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [signUserStatus, setSignUserStatus] = useState([]);
  const [signInData, setSignInData] = useState({ link: null, isActive: null });
  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [socket, setSocket] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { handleRedirection } = useHandleRedirection()

  const { oppId } = useParams();
  const { applicantData, isLoading, applicantEditPreview } = useSelector(
    (state) => state.newBookingForm
  );

  useEffect(() => {
    connect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let list = [];
    if (applicantData?.noOfApplicants) {
      for (let i = 1; i <= applicantData?.noOfApplicants; i++) {
        if (applicantData[`applicant${i}`] !== null) {
          list.push({
            name: `${getName(applicantData?.leegalityData, i)}`,
            value: i,
            link: getLink(applicantData?.leegalityData, i),
            isActive: getIsActive(applicantData?.leegalityData, i),
            email: getEmail(applicantData?.leegalityData, i),
            isSigned: getSigned(applicantData?.leegalityData, i),
            isMinor: applicantData[`applicant${i}`]?.hasContinuedAsMinor || false,
            minorName: applicantData[`applicant${i}`]?.personalDetails?.firstName
          });
        }
      }
    }
    setApplicatList(list || []);
  }, [applicantData]);

  useEffect(() => {
    // if (
    //   applicantData?.bookingFormStatus === BOOKING_FORM_STATUS?.SIGNED ||
    //  (applicantData?.bookingFormStatus === BOOKING_FORM_STATUS?.SIGNED_OFFLINE && applicantData?.formSignedAt) ||
    //   signUserStatus?.bookingFormStatus === BOOKING_FORM_STATUS?.SIGNED
    // ) {
    //   window.location.href = `/feedback/${oppId}`;
    // }
    handleRedirection("", "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicantData, windowPopup]);

  useEffect(() => {
    // if (signUserStatus?.bookingFormStatus === BOOKING_FORM_STATUS?.SIGNED) {
    //   window.location.href = `/feedback/${oppId}`;
    // }
    handleRedirection(null, signUserStatus?.bookingFormStatus)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signUserStatus?.bookingFormStatus]);


  function connect() {
    // const socketClient = io("http://purv-ws.iprotec.in", {
    //   path: "booking_events", // Set the path without a leading or trailing slash
    //   query: { oppId: oppId },
    //   transports: ["websocket"],
    //   // timeout: 10000, // 20 seconds (increase as needed)
    // });
    const socketClient = io(`${REACT_APP_SOCKET_SERVER_URL}?oppId=${oppId}`);

    //console.log("Attempting to connect to:", socketClient.io.uri);
    //console.log("Socket.io Connection Options:", socketClient.io.opts);
    setSocket(socketClient);

    socketClient.on("connect", () => {
      console.log("Connected to WebSocket server.");
    });

    socketClient.on("connect_error", (error) => {
      console.log("Connection error:", error);
    });

    socketClient.on("disconnect", () => {
      console.warn("Disconnected from WebSocket server.");
    });

    socketClient.on("opportunity_update", (opportunity_update) => {
      // here we have implement our logic once messaage revice from BE side
      // console.log("opportunity_update received:", opportunity_update);
      setSignUserStatus(opportunity_update);
      if (windowPopup && !windowPopup.closed) {
        windowPopup.close();

        dispatch(getApplicantDetails(`/${oppId}`))
          .unwrap()
          .then((res) => {
            if (res) {
              handleRedirection(res, "")
            }
          })
          .catch((error) => {
            if (!error?.message?.includes("Booking with Opportunity")) {
              setSnackBarconfig({
                open: true,
                message: ERROR_MESSAGE,
                severity: "error",
              });
            }
            handleRedirection();
            //history.push(`/booking-form/${oppId}`)
          });

        windowPopup = "";
      }
    });

    return () => {
      socketClient.disconnect();
    };
  }

  const getLink = (dataList, i) => {
    if (dataList !== null || typeof dataList !== "undefined") {
      if (dataList?.invitees && dataList?.invitees?.length > 0) {
        return dataList?.invitees?.[i - 1]?.signUrl;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const getEmail = (dataList, i) => {
    if (dataList !== null || typeof dataList !== "undefined") {
      if (dataList?.invitees && dataList?.invitees?.length > 0) {
        return dataList?.invitees?.[i - 1]?.email;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const getName = (dataList, i) => {
    if (dataList !== null || typeof dataList !== "undefined") {
      if (dataList?.invitees && dataList?.invitees?.length > 0) {
        return dataList?.invitees?.[i - 1]?.name?.split(" ")[0];
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const getSigned = (dataList, i) => {
    if (dataList !== null || typeof dataList !== "undefined") {
      if (dataList?.invitees && dataList?.invitees?.length > 0) {
        return dataList?.invitees?.[i - 1]?.isSigned || false;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const getIsActive = (dataList, i) => {
    if (dataList !== null || typeof dataList !== "undefined") {
      if (dataList?.invitees && dataList?.invitees?.length > 0) {
        return dataList?.invitees?.[i - 1]?.active ? true : false;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  const handleSignIn = () => {
    if (!signInData?.isActive) {
      let payload = {
        signUrl: signInData?.link !== null ? signInData?.link : null,
      };
      dispatch(
        signForApplicant({
          path: `${route.ACTIVATE_INVITATION}`,
          payload: payload,
        })
      )
        .unwrap()
        .then((res) => {
          if (res?.statusCode === 200 || res?.statusCode === 201) {
            setShowModal(false);
            openWindow(signInData?.link);
          }
        })
        .catch((error) => {
          setShowModal(false);
          setSnackBarconfig({
            open: true,
            message: ERROR_MESSAGE,
            severity: "error",
          });
        });
    } else {
      setShowModal(false);
      openWindow(signInData?.link);
    }
  };

  const openWindow = (link) => {
    const url = link; // Replace with your URL
    const width = 1200; // Width of the popup
    const height = 900; // Height of the popup
    const left = window.screen.width / 2 - width / 2; // Center horizontally
    const top = window.screen.height / 2 - height / 2; // Center vertically
    dispatch(getApplicantDetails(`/${oppId}`));
    windowPopup = window.open(
      url,
      "PopupWindow",
      `width=${width},height=${height},top=${top},left=${left}`
    );
  };

  const handleSignInLater = () => {
    let payload = {
      opportunityId: oppId,
      signUrls: [signInData?.link],
      bookingAs: applicantData?.bookingAs,
    };
    dispatch(
      signForApplicant({
        path: `${route.RESEND_NOTIFICATION}`,
        payload: payload,
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.statusCode === 200 || res?.statusCode === 201) {
          setShowModal(false);
          setSnackBarconfig({
            open: true,
            message: res?.data?.invitations?.[0]?.message,
            severity: "success",
          });
          dispatch(getApplicantDetails(`/${oppId}`));
          setTimeout(() => {
            if (res?.data.isRedirectable === true) {
              window.location.href = `/feedback/${oppId}`;
            }
          }, 3000);
        }
      })
      .catch((error) => {
        setSnackBarconfig({
          open: true,
          message: ERROR_MESSAGE,
          severity: "error",
        });
      });
  };

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
      <div className="kycDocument signApplicant">
        <div className="applicantDetailsCard">
          {/* <CommentBox isDisabled={true} value={comment} /> */}
          <div className="marginBottom16">
            <label className="checkTerms">
              &nbsp; I have read and agree to the terms and conditions
              <input
                type="checkbox"
                onChange={(e) => {
                  setAcceptTermsAndCondition(e?.target?.checked);
                }}
              />
              <span className="checkmark"></span>
            </label>
          </div>

          <div className="eSignature">
            {/* What is an eSignature? <img src={alertCircle} alt="" /> */}
            <Tooltip
              enterTouchDelay={0}
              title={
                <React.Fragment>
                  <div className="hoverTooltip">
                    <span>
                      Step 1: Choose your preferred method for digitally
                      capturing your signature.
                    </span>
                    <span>
                      Step 2: If you opt for Aadhaar verification, an OTP will
                      be sent to your registered mobile number. Enter the OTP to
                      securely validate your identity.
                    </span>
                    <span>
                      Step 3: Once validated, your signature will be
                      automatically applied.
                    </span>
                    <span>
                      Step 4: Alternatively, if you choose not to use Aadhaar
                      you can manually create and place your virtual signature.
                    </span>
                  </div>
                </React.Fragment>
              }
            >
              What is an eSignature? <img src={alertCircle} alt="" />
            </Tooltip>
          </div>

          <div className="signBtn">
            {applicatList &&
              applicatList?.length > 0 &&
              applicatList?.map((data, index) => {
                const isCurrentUser = signUserStatus?.phone
                  ? signUserStatus?.email === data?.email && signUserStatus?.phone === data?.phone
                  : signUserStatus?.email === data?.email;

                const isSigned = isCurrentUser || data?.isSigned;

                const isDisabled = isSigned ? true : !acceptTermsAndCondition;

                return (
                  <button
                    key={index}
                    className={`${
                      isSigned
                        ? "disableCTA"
                        : acceptTermsAndCondition
                        ? ""
                        : "disableCTA"
                    }`}
                    onClick={() => {
                      setSignInData({
                        link: data?.link,
                        isActive: data?.isActive,
                      });
                      setShowModal(true);
                    }}
                    disabled={isDisabled}
                  >
                    {isSigned
                      ? `${
                          data?.isMinor
                            ? `Signed on the behalf of ${data?.minorName}`
                            : `${data?.name} signed`
                        }`
                      : `${
                          data?.isMinor ? "Sign on behalf of " : "Sign for "
                        } ${data?.isMinor ? data?.minorName : data?.name}`}
                    {isSigned && <img src={checkIcon} alt="" />}
                  </button>
                );
              })}

          </div>
        </div>
      </div>
      {showModal ? (
        <SignInModal
          handleSignIn={handleSignIn}
          handleSignInLater={handleSignInLater}
          setShowModal={setShowModal}
        />
      ) : null}
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default TermsAndConditionPreview;
